module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/th_2-c984f888703fde09b8cfb97f0031742a.jpg";